// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search-note {\n  width: 250px;\n  border: none;\n}\n\n.cbo-search-sm {\n  width: 110px;\n  background-color: transparent !important;\n  margin-left: -10px;\n  padding-bottom: -5px;\n  font-size: 1em;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
